const form = document.querySelector("form.stabildrill-conroe-form");

if (form) {
  form.addEventListener("submit", function(event) {
    event.preventDefault();

    const formData = new FormData(form);
    const thankYouPage = form.querySelector("#thank-you-page").getAttribute("href");
    const button = form.querySelector("button[type='submit']");
    button.disabled = true;

    fetch(form.action, {
      method: "POST",
      body: formData,
    })
    .then(response => {
      //window.location.href = "/thank-you";
    })
    .catch((error) => {
      //window.location.href = "/thank-you";
    })
    .finally(() => {
      form.setAttribute("action", thankYouPage);
      form.submit();
    });
  });
}